import { render, staticRenderFns } from "./ContentsAffirm.vue?vue&type=template&id=e37ed64a&"
import script from "./ContentsAffirm.vue?vue&type=script&lang=js&"
export * from "./ContentsAffirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports